import { boolean, object, string } from "yup";

const fieldRequiredMessage = "Este campo es obligatorio.";
const validOptionText = "Por favor, selecciona una opción válida.";
const stringOptional = string();
const booleanRequired = boolean().required(fieldRequiredMessage);

const priceValueRequired = string()
  .min(1, fieldRequiredMessage)
  .test(
    "only-numbers-commas-dots",
    "El valor debe contener solo números, puntos y comas.",
    (value) => {
      if (!value) return true;

      return /^[0-9.,]+$/.test(value);
    }
  );

const radioOrSingleSelectRequired = (options: string[]) =>
  string()
    .oneOf(
      options.map((option) => option),
      validOptionText
    )
    .required(fieldRequiredMessage);

// ========== VALIDATION SCHEMA ==========

export const createOperateSchema = () =>
  object().shape({
    account: stringOptional,
    side: radioOrSingleSelectRequired(["BUY", "SELL"]),
    operationValueArs: priceValueRequired,
    operationValueMep: priceValueRequired,
    isTotal: booleanRequired,
    acceptedTermsAndConditions: booleanRequired,
  });

export const operateSchema = createOperateSchema();
